export enum REG_INV_GROUP_SEARCH_MAP {
	THEME_NAME_GROUP = 'themeNameList',
	SECTION_NAME_GROUP = 'sectionNameList',
	JURISDICTION_GROUP = 'jurisdictionList',
	CREATED_BY_GROUP = 'createdByName',
	ASSIGNED_BY_GROUP = 'assignedUserName',
	PRIORITY_GROUP = 'priority',
}

export enum REG_INV_REGULATION_SEARCH_MAP {
	THEME_NAME = 'themeName',
	SECTION_NAME = 'sectionName',
	JURISDICTION = 'jurisdiction',
	CREATED_BY = 'createdByList',
	ASSIGNED_BY = 'assignedUserName',
	PRIORITY = 'priorityList',
}

export enum REG_INV_REGULATION_SEARCH_TYPE {
	REGULATION = 'regulation',
	GROUP = 'group',
}

export enum REG_INV_FILTER_NAME {
	US_FEDERAL = 'US Federal',
	US_STATES = 'US States',
	INTERNATIONAL = 'International',
}

export enum REG_INV_EXPORT_COLUMN_NAMES {
	GROUP_NAME = 'groupName',
	SUMMARY = 'summary',
	GROUP_APPROVED_BY = 'groupApprovedBy',
	SUMMARY_APPROVED_BY = 'summaryApprovedBy',
	BOOK_TITLE = 'bookTitle',
	ISSUER = 'issuer',
	JURISDICTION_EXPORT = 'jurisdiction',
	GROUP_APPROVED_ON = 'groupApprovedOn',
	SOURCE_LINK = 'sourceLink',
	SUMMARY_MODIFIED_DATE = 'summaryModifiedDate',
	PARAGRAPH_ID = 'paragraphId',
	THEME_LIST = 'themeList',
}

export enum REG_INV_CARD_NAMES {
	FEDERAL_REGULATIONS = 'Federal Regulations',
	STATE_REGULATIONS = 'State Regulations',
	FEDERAL_LAWS = 'Federal Laws',
	FEDERAL_GUIDANCE = 'Federal Guidance',
	STATE_LAWS = 'State Laws',
	STATE_GUIDANCE = 'State Guidance',
	INTERNATIONAL_REGULATIONS = 'International Regulations',
	INTERNATIONAL_LAW = 'International Laws',
	INTERNATIONAL_GUIDANCE = 'International Guidance',
	INDUSTRY_GUIDANCE = 'Industry Guidance',
}

export enum REGULATION_TAB_VALUES {
	CURRENT_INVENTORY = 'Current Inventory',
	BUILD_WORKFLOW = 'Build WorkFlow',
	HORIZON_SCANNING = 'Horizon Scanning',
}

export enum BUILDWORKFLOW_CARD_COUNT {
	NOT_STARTED = 'Not Started',
	APPLICATION = 'Applicability',
	GROUPING = 'Grouping',
	MAPPING = 'Mapping',
	SUMMARY = 'Summary',
	COMPLETE = 'Complete',
}

export enum CURRENTINV_CARD_COUNT {
	OBLIGATION = 'Obligations',
	REGULATION = 'Regulations',
	ASSIGNED = 'Assigned to me',
	BUSINESS_UNIT = 'Business Units',
	PROCESS = 'Processes',
	RISK = 'Risks',
	CONTROL = 'Controls',
	POLICY = 'Policies',
}

export enum AI_CARD_CONTENT {
	PROCESSING = 'AI generator is experiencing longer processing times...',
	NO_DATA = 'Nothing here at the moment, please add new or generate.',
	NO_DATA_SEARCH = 'No Data Found',
}

export enum REG_INV_CARD_TYPE {
	WORK_FLOW = 'work flow',
	INVENTORY = 'inventory',
}

export enum SUMMARY_ERROR_MESSAGE {
	SAVE_SUCCESS = 'Summary saved successfully',
	SAVE_ERROR = 'Failed to save summary',
	REGENERATE_ERROR = 'Failed to regenerate summary',
	REGENERATE_SUCCESS = 'Summary regenerated successfully',
}

export const regInventoryHorizonSummaryTab = [
	'Change summary',
	'Relevant obligation(s)',
];
